"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Buttons/Button"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _InputGroup = _interopRequireDefault(require("react-bootstrap/InputGroup"));
var _Popover = _interopRequireDefault(require("react-bootstrap/Popover"));
var _OverlayTrigger = _interopRequireDefault(require("react-bootstrap/OverlayTrigger"));
var _FormHelperText = _interopRequireDefault(require("./FormHelperText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PrependIcon = _ref => {
  let {
    icon
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_InputGroup.default.Prepend, null, /*#__PURE__*/_react.default.createElement(_InputGroup.default.Text, null, /*#__PURE__*/_react.default.createElement("span", {
    className: `icon-${icon}`
  })));
};
PrependIcon.propTypes = {
  icon: _propTypes.default.string.isRequired
};
const PrependAmount = () => /*#__PURE__*/_react.default.createElement(_InputGroup.default.Prepend, null, /*#__PURE__*/_react.default.createElement(_InputGroup.default.Text, null, "$"));
const AppendPercent = () => /*#__PURE__*/_react.default.createElement(_InputGroup.default.Append, null, /*#__PURE__*/_react.default.createElement(_InputGroup.default.Text, null, "%"));
const AppendPopover = _ref2 => {
  let {
    disabled,
    icon,
    id,
    text
  } = _ref2;
  const BasicPopover = /*#__PURE__*/_react.default.createElement(_Popover.default, {
    id: `${id}-basic-popover`
  }, /*#__PURE__*/_react.default.createElement(_Popover.default.Content, null, text));
  return /*#__PURE__*/_react.default.createElement(_InputGroup.default.Append, null, /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    overlay: BasicPopover,
    placement: "auto",
    rootClose: true,
    trigger: "click"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "link",
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Information"), /*#__PURE__*/_react.default.createElement("span", {
    className: `icon-${icon}`,
    "aria-hidden": "true",
    title: "Information"
  }))));
};
AppendPopover.propTypes = {
  icon: _propTypes.default.string,
  id: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  text: _propTypes.default.string.isRequired
};
AppendPopover.defaultProps = {
  disabled: false,
  icon: 'info'
};
const AppendPassword = _ref3 => {
  let {
    disabled,
    onClick,
    masked
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_InputGroup.default.Append, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "link",
    onClick: onClick,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, masked ? 'Show Password' : 'Hide Password'), /*#__PURE__*/_react.default.createElement("span", {
    className: masked ? 'icon-eye-hide' : 'icon-eye-show',
    "aria-hidden": "true",
    title: masked ? 'Show Password' : 'Hide Password'
  })));
};
AppendPassword.propTypes = {
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  masked: _propTypes.default.bool
};
AppendPassword.defaultProps = {
  disabled: false,
  masked: false
};
const AppendSpinner = _ref4 => {
  let {
    active,
    id
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_InputGroup.default.Append, null, /*#__PURE__*/_react.default.createElement(_InputGroup.default.Text, {
    id: id
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Loading..."), /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true",
    className: active ? 'spinner-border' : 'spinner-border disabled',
    role: "status"
  })));
};
AppendSpinner.propTypes = {
  active: _propTypes.default.bool,
  id: _propTypes.default.string
};
AppendSpinner.defaultProps = {
  active: false
};
const inputGroupClassName = (isValid, isInvalid, htmlSize) => {
  const elem = document.createElement('div');
  if (isValid) elem.classList.add('is-valid');
  if (isInvalid) elem.classList.add('is-invalid');
  if (htmlSize) elem.classList.add('input-group--size');
  return elem.classList.value;
};

/**
 * An Input Group for use in Forms.
 *
 * Input Groups consist of any number of "prepended" controls, such as text
 * or buttons, as well as any number of "appended" controls, such as text
 * or buttons. An Input Group without anything prepended or appended is
 * a plain FormInput.
 */
const FormInputGroup = props => {
  const {
    alignRight,
    disabled,
    errorText,
    feedbackType,
    hasError,
    helperText,
    htmlSize,
    id,
    inputGroupType,
    labelText,
    placeholderText,
    popoverIcon,
    popoverText,
    preceedingIcon,
    spinnerActive,
    ...rest
  } = props;
  const [masked, setMasked] = (0, _react.useState)(inputGroupType === 'password');
  const onClick = () => {
    setMasked(!masked);
  };
  const inputClassName = alignRight ? 'mm-text-right' : '';
  const feedbackText = helperText || errorText;
  rest.isValid = feedbackType === 'valid';
  rest.isInvalid = feedbackType === 'invalid' || hasError;
  return /*#__PURE__*/_react.default.createElement(_Form.default.Group, null, /*#__PURE__*/_react.default.createElement(_Form.default.Label, {
    htmlFor: id
  }, labelText), /*#__PURE__*/_react.default.createElement(_InputGroup.default, {
    className: inputGroupClassName(rest.isValid, rest.isInvalid, htmlSize),
    disabled: disabled
  }, inputGroupType === 'icon' && /*#__PURE__*/_react.default.createElement(PrependIcon, {
    icon: preceedingIcon
  }), inputGroupType === 'amount' && /*#__PURE__*/_react.default.createElement(PrependAmount, null), /*#__PURE__*/_react.default.createElement(_Form.default.Control, _extends({
    "aria-describedby": feedbackText && `${id}-description`,
    "aria-invalid": rest.isInvalid,
    className: inputClassName,
    disabled: disabled,
    htmlSize: htmlSize,
    id: id,
    inputMode: inputGroupType === 'amount' || inputGroupType === 'percent' ? 'numeric' : undefined,
    placeholder: placeholderText,
    type: masked ? 'password' : 'text'
  }, rest)), inputGroupType === 'percent' && /*#__PURE__*/_react.default.createElement(AppendPercent, null), inputGroupType === 'popover' && /*#__PURE__*/_react.default.createElement(AppendPopover, {
    disabled: disabled,
    icon: popoverIcon,
    id: id,
    text: popoverText
  }), inputGroupType === 'password' && /*#__PURE__*/_react.default.createElement(AppendPassword, {
    masked: masked,
    onClick: onClick
  }), inputGroupType === 'spinner' && /*#__PURE__*/_react.default.createElement(AppendSpinner, {
    active: spinnerActive,
    id: `${id}-description`
  })), /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
    id: `${id}-description`,
    feedbackType: feedbackType,
    helperText: feedbackText
  }));
};
FormInputGroup.propTypes = {
  /**
   * Align input group text right.
   */
  alignRight: _propTypes.default.bool,
  /**
   * Disable user input on this input.
   */
  disabled: _propTypes.default.bool,
  /**
   * Deprecated. Please use `helperText` for all feedback text types.
   */
  errorText: _propTypes.default.string,
  /**
   * Control the feedback text to appear as helper text, valid, or invalid feedback.
   */
  feedbackType: _propTypes.default.oneOf(['helper', 'valid', 'invalid']),
  /**
   * Deprecated. Please use `feedbackType` for all feedback types.
   */
  hasError: _propTypes.default.bool,
  /**
   * The helper text for an input.
   */
  helperText: _propTypes.default.string,
  /**
   * Size of the input
   */
  htmlSize: _propTypes.default.number,
  /**
   * The `ID` for the input & `htmlFor` the label
   */
  id: _propTypes.default.string.isRequired,
  /**
   * The type of input group
   */
  inputGroupType: _propTypes.default.oneOf(['amount', 'icon', 'percent', 'popover', 'password', 'spinner']).isRequired,
  /**
   * The label text
   */
  labelText: _propTypes.default.string,
  /**
   * The placeholder text
   */
  placeholderText: _propTypes.default.string,
  /**
   * The icon for the popover. You can find the list of icons in Blueprint-CSS.
   */
  popoverIcon: _propTypes.default.string,
  /**
   * The message contents for the popover
   */
  popoverText: _propTypes.default.string,
  /**
   * Set preceeding icon. You can find the list of icons in Blueprint-CSS.
   */
  preceedingIcon: _propTypes.default.string,
  /**
   * If the input is required
   */
  required: _propTypes.default.bool,
  /**
   * A boolean for if the spinner is active
   */
  spinnerActive: _propTypes.default.bool
};
FormInputGroup.defaultProps = {
  alignRight: false,
  disabled: false,
  spinnerActive: false
};
var _default = exports.default = FormInputGroup;